module.exports = __webpack_public_path__ + "img/user.ea998f95.svg";